// Modules
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormBuilderModule } from './fb.module';
import { ToastrModule } from 'ngx-toastr';

// Components
import { BootstrapComponent } from './components/bootstrap/bootstrap.component';

// Utils
import { IDGSEnvironment, DGSCoreModule, DGSUICoreModule } from '@dotgov/z_core';
import { BuilderEnvironment } from './environment';
import { environment } from '../../environments/environment';
import { ENVIRONMENT_NAME } from '../constants';

const toastrDefaultOptions = {
  positionClass: 'toast-bottom-right',
  preventDuplicates: true,
  enableHtml: true,
};

@NgModule({
  declarations: [BootstrapComponent],
  imports: [
    BrowserModule,
    DGSCoreModule.forRoot({ apiUrl: 'http://moldova.api/' }),
    DGSUICoreModule,
    FormBuilderModule,
    ToastrModule.forRoot(toastrDefaultOptions),
  ],
  providers: [],
  exports: [BootstrapComponent],
  bootstrap: [BootstrapComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DevFormBuilderModule {
  public static forRoot(_enviroment: IDGSEnvironment = BuilderEnvironment.CONFIG()): ModuleWithProviders {
    return {
      ngModule: DevFormBuilderModule,
      providers: [
        FormBuilderModule.forRoot(_enviroment).providers,
        { provide: 'enviroment', useValue: _enviroment || environment[ENVIRONMENT_NAME] },
      ],
    };
  }
}
